import React, { useContext, useState } from 'react'
import './index.scss'
import Button from '@Components/Buttons/Button'
import ModalPortal from '@Components/Popups/ModalPortal'
import ShareAmendConfirmationPopup from '@Components/Popups/ShareAmendConfirmationPopup'
import { StoresContext } from '@App/contexts'
import { useNavigate } from 'react-router'
import Navigation from '@App/navigation'

export interface AmendSharesOptionsProps {
    onCancelAmendOption: () => void
    onConfirmAmendOption: () => Promise<void>
    disabled: boolean
}
const AmendSharesOptions = (props: AmendSharesOptionsProps) => {
    const { onCancelAmendOption, onConfirmAmendOption, disabled } = props
    const { userStore, rightsholderStore } = useContext(StoresContext)
    const [displayAmendPopup, setDisplayAmendPopup] = useState<boolean>(false)

    const navigate = useNavigate()
    const onAmend = async () => {
        await onConfirmAmendOption()
        setDisplayAmendPopup(true)
    }

    const onRedirect = () => {
        setDisplayAmendPopup(false)
        navigate(Navigation.rightholder.registrationHistory.pending(rightsholderStore.currentRightsholderId))
    }

    return (
        <div className="amend-share-wrapper">
            <ModalPortal isOpen={displayAmendPopup}>
                <ShareAmendConfirmationPopup onClose={() => onRedirect()} />
            </ModalPortal>
            <div className="amend-shares-options">
                <div className="top-section">
                    <h6>Confirm your amended shares</h6>
                    <p>
                        Click &quot;Confirm&quot; to confirm the new share percentage entered above, or click
                        &quot;Cancel&quot; to return to the main Overclaims page.
                    </p>
                </div>
                <div className="buttons-area">
                    <Button type="primary" mainColor onClick={onCancelAmendOption}>
                        Cancel
                    </Button>
                    <Button type="primary" mainColor onClick={onAmend} disabled={disabled || userStore.isInternal}>
                        Confirm
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default AmendSharesOptions
